"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UnlockFilledIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991zM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill-rule="nonzero" d="M8 6.251v-.249A4.004 4.004 0 0 1 12 2a4 4 0 0 1 4 4.002V6.5h-2v-.498A2 2 0 0 0 12 4c-1.102 0-2 .898-2 2.002V11H8zm6 .249h2a1 1 0 0 1-2 0"/></g></svg>`
}, props));
UnlockFilledIcon.displayName = 'UnlockFilledIcon';
var _default = exports.default = UnlockFilledIcon;